import React from 'react';
import { BorderProps, border, LayoutProps, layout } from 'styled-system';
import styled from 'styled-components';

type ImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  objectPosition?: string;
} & BorderProps &
  LayoutProps;

export const StyledImg = styled.img<ImageProps>(border, layout, ({ objectPosition }) => ({
  userSelect: 'none',
  objectPosition: objectPosition ?? 'center',
}));
